module.exports = __webpack_public_path__ + "static/media/arrowTop.819151d5.svg";